import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'cz-ausnahme-popup',
    templateUrl: './ausnahme-popup.component.html',
    styleUrls: ['./ausnahme-popup.component.css'],
    standalone: false
})
export class AusnahmePopupComponent {

  public eventsSubject: Subject<any> = new Subject<any>();

  popupVisible: boolean;
  isSaving: boolean = false;
  @Input() eId: number;
  @Input() label: string = 'Ausnahme';
  @Input() optional: any;

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCloseOk: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.save = this.save.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  save() {
    this.isSaving = true;
    this.eventsSubject.next('Save');
  }

  showPopup() {
    this.popupVisible = true;
  }

  closePopup() {
    this.eventsSubject.next('Close');
    this.popupVisible = false;
    this.onClose.emit(null);
  }

  onCloseOkEvent(event) {
    this.eventsSubject.next('Close');
    this.popupVisible = false;
    this.onCloseOk.emit(event);
    this.isSaving = false;
  }

  onNotValid(event){
    this.isSaving = false;
  }
}
